import React, { useState } from 'react';
import './chatbot.css';
import { useLocation } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box, IconButton, Zoom, Tooltip } from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';
import CloseIcon from '@mui/icons-material/Close';
import logo from '../../../seffaf/static/img/orthero_icon.png';
import DashboardIcon from '@mui/icons-material/Dashboard';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import VideocamIcon from '@mui/icons-material/Videocam';

/* ── Chat ile ilgili importlar (devre dışı) ──────────────────────
import { useEffect, useRef } from 'react';
import { Tab, Tabs } from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';
import AddIcon from '@mui/icons-material/Add';
import SendIcon from '@mui/icons-material/Send';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
─────────────────────────────────────────────────────────────────── */

const ChatbotComponent = () => {
    const [showBot, setShowBot] = useState(false);
    const [isDocked, setIsDocked] = useState(true);
    const theme = useTheme();
    const location = useLocation();
    const isViewerPage = (location.pathname || '').includes('/viewer');

    const isMobile = typeof window !== 'undefined' &&
        (/Mobi|Android|iPhone|iPad|iPod/.test(navigator.userAgent) || window.innerWidth < 768);

    const userData = JSON.parse(localStorage.getItem('userData') || '{}');
    const miyName = (userData?.miy_name || '').trim();

    const pipedriveSchedulerUrl = (() => {
        const base = 'https://seffafapareyorthero.pipedrive.com/scheduler';
        const normalized = (miyName || '')
            .toLowerCase()
            .replace(/ş/g, 's')
            .replace(/ı/g, 'i')
            .replace(/ğ/g, 'g')
            .replace(/ü/g, 'u')
            .replace(/ö/g, 'o')
            .replace(/ç/g, 'c')
            .trim();
        if (/serap\s*arslan/.test(normalized)) return `${base}/4x0ALYt0/orthero-meeting`;
        if (/vildan\s*evciman/.test(normalized)) return `${base}/3xbAjatm/orthero-meeting`;
        if (/gizem\s*ayazlı/.test(miyName.toLowerCase()) || /gizem\s*ayazlı/.test(normalized)) return `${base}/XqPQ0ks7/orthero-meeting`;
        return `${base}/3xbAjatm/orthero-meeting`;
    })();

    /* ── Chat Sessions & Audio state (devre dışı) ────────────────
    const [sessions, setSessions] = useState([
        { id: 1, title: 'Chat 1', key: Date.now() }
    ]);
    const [activeSession, setActiveSession] = useState(1);
    const [nextSessionId, setNextSessionId] = useState(2);
    const n8nInitialized = useRef({});
    const [showMeeting, setShowMeeting] = useState(false);
    const [isRecording, setIsRecording] = useState(false);
    const [recordingStartTime, setRecordingStartTime] = useState(null);
    const recordingStartTimeRef = useRef(null);
    const [recordingElapsed, setRecordingElapsed] = useState(0);
    const [isUploadingAudio, setIsUploadingAudio] = useState(false);
    const [reviewBlob, setReviewBlob] = useState(null);
    const [reviewUrl, setReviewUrl] = useState(null);
    const [reviewDurationMs, setReviewDurationMs] = useState(0);
    const [playbackRate, setPlaybackRate] = useState(1.0);
    const fileInputRef = useRef(null);
    const mediaRecorderRef = useRef(null);
    const recordedChunksRef = useRef([]);
    const cancelRecordingRef = useRef(false);
    const reviewAudioRef = useRef(null);
    ─────────────────────────────────────────────────────────────── */

    const toggleBot = () => {
        setIsDocked(true);
        setShowBot((prev) => !prev);
    };
    const toggleDockMode = () => {
        setIsDocked((prev) => !prev);
    };

    /* ── Chat fonksiyonları (devre dışı) ─────────────────────────

    const addNewChat = () => {
        const newSession = {
            id: nextSessionId,
            title: `Chat ${nextSessionId}`,
            key: Date.now() + nextSessionId
        };
        setSessions((prev) => [...prev, newSession]);
        setActiveSession(nextSessionId);
        setNextSessionId((prev) => prev + 1);
    };
    const closeChat = (sessionId, event) => {
        event.stopPropagation();
        if (sessions.length === 1) {
            return;
        }
        setSessions((prev) => {
            const newSessions = prev.filter((s) => s.id !== sessionId);
            if (activeSession === sessionId) {
                setActiveSession(newSessions[0].id);
            }
            return newSessions;
        });
        delete n8nInitialized.current[sessionId];
    };

    const handleChangeSession = (event, newValue) => {
        setActiveSession(newValue);
    };
    const emitFile = (file, meta = {}) => {
        try {
            window.dispatchEvent(new CustomEvent('orthero-chatbot-attachment', { detail: { file, ...meta } }));
        } catch (e) {
            console.log(e);
        }
        console.log('Attachment prepared:', meta, file);
    };
    const uploadAudioToN8n = async (file, durationMs) => {
        try {
            setIsUploadingAudio(true);
            
            const reader = new FileReader();
            const base64Promise = new Promise((resolve, reject) => {
                reader.onload = () => {
                    const base64 = reader.result
                    .split(',')[1]
                    .replace(/[^A-Za-z0-9+/=]/g, ''); 
                    resolve(base64);
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
            
            const audioBase64 = await base64Promise;
            window.__ortheroPendingAudio = {
                audioBase64: audioBase64,
                audioMime: file.type,
                audioFilename: file.name,
                audioDuration: Math.floor(durationMs / 1000),
                sessionId: activeSession
            };
            
            console.log('Sending audio via n8n widget:', {
                size: audioBase64.length,
                mime: file.type,
                duration: durationMs
            });
            if (window.__ortheroSendUserText) {
                window.__ortheroSendUserText(activeSession, 'Sesli mesaj');
            }
            
        } catch (error) {
            console.error('Audio upload error:', error);
            window.__ortheroPendingAudio = null;
            if (window.__ortheroAppendMessage) {
                window.__ortheroAppendMessage(activeSession, 'bot', "Ses yuklenemedi. Lutfen tekrar deneyin.");
            }
        } finally {
            setIsUploadingAudio(false);
        }
    };

    const handleChooseAnyFile = () => {
        if (fileInputRef.current) fileInputRef.current.click();
    };

    const handleAnyFileChange = (e) => {
        const file = e.target.files && e.target.files[0];
        if (file) {
            const isImage = (file.type || '').startsWith('image/');
            emitFile(file, { kind: isImage ? 'image' : 'file' });
            try {
                const prefix = isImage ? 'Resim' : 'Dosya';
                const text = prefix + ' yuklendi: ' + file.name;
                if (window.__ortheroSendUserText) {
                    window.__ortheroSendUserText(activeSession, text);
                }
            } catch (err) {
                console.log(err);
            }
        }
        e.target.value = '';
    };

    const startAudioRecording = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            const mediaRecorder = new MediaRecorder(stream);
            recordedChunksRef.current = [];
            mediaRecorder.ondataavailable = (event) => {
                if (event.data && event.data.size > 0) {
                    recordedChunksRef.current.push(event.data);
                }
            };
            mediaRecorder.onstop = async () => {
                const wasCancelled = cancelRecordingRef.current;
                cancelRecordingRef.current = false;
                if (window.__ortheroUpdateRecordingState) {
                    window.__ortheroUpdateRecordingState(activeSession, false);
                }
                if (!wasCancelled) {
                    const blob = new Blob(recordedChunksRef.current, { type: 'audio/webm' });
                    const durationMs = Date.now() - (recordingStartTimeRef.current || Date.now());
                    try {
                        if (reviewUrl) URL.revokeObjectURL(reviewUrl);
                    } catch (e) {}
                    const url = URL.createObjectURL(blob);
                    setReviewBlob(blob);
                    setReviewUrl(url);
                    setReviewDurationMs(durationMs);
                }
                stream.getTracks().forEach((t) => t.stop());
                setIsRecording(false);
                setRecordingStartTime(null);
                setRecordingElapsed(0);
                recordingStartTimeRef.current = null;
            };
            mediaRecorder.start();
            mediaRecorderRef.current = mediaRecorder;
            setIsRecording(true);
            const now = Date.now();
            setRecordingStartTime(now);
            recordingStartTimeRef.current = now;
            setRecordingElapsed(0);
            setIsUploadingAudio(false);
            if (window.__ortheroUpdateRecordingState) {
                window.__ortheroUpdateRecordingState(activeSession, true);
            }
        } catch (error) {
            console.error('Audio recording error:', error);
            setIsRecording(false);
            if (window.__ortheroUpdateRecordingState) {
                window.__ortheroUpdateRecordingState(activeSession, false);
            }
        }
    };

    const stopAudioRecording = () => {
        const mr = mediaRecorderRef.current;
        if (mr && mr.state !== 'inactive') {
            mr.stop();
        }
    };

    const cancelAudioRecording = () => {
        cancelRecordingRef.current = true;
        stopAudioRecording();
    };

    useEffect(() => {
        const handler = () => {
            if (isRecording) {
                stopAudioRecording();
            } else {
                startAudioRecording();
            }
        };
        window.addEventListener('orthero-chatbot-mic-toggle', handler);
        return () => window.removeEventListener('orthero-chatbot-mic-toggle', handler);
    }, [isRecording]);

    useEffect(() => {
        if (!isRecording || !recordingStartTime) return;
        const id = setInterval(() => {
            setRecordingElapsed(Date.now() - recordingStartTime);
        }, 200);
        return () => clearInterval(id);
    }, [isRecording, recordingStartTime]);

    useEffect(() => {
        const shouldDisable = isRecording || isUploadingAudio || !!reviewBlob;
        if (window.__ortheroSetMicButtonDisabled) {
            window.__ortheroSetMicButtonDisabled(activeSession, shouldDisable);
        }
    }, [isRecording, isUploadingAudio, reviewBlob, activeSession]);

    const formatElapsed = (ms) => {
        const total = Math.max(0, Math.floor(ms / 1000));
        const mm = String(Math.floor(total / 60)).padStart(2, '0');
        const ss = String(total % 60).padStart(2, '0');
        return mm + ':' + ss;
    };

    const clearReview = () => {
        try { if (reviewUrl) URL.revokeObjectURL(reviewUrl); } catch (e) {}
        setReviewUrl(null);
        setReviewBlob(null);
        setReviewDurationMs(0);
        setPlaybackRate(1.0);
    };

    const handleSendReviewedAudio = async () => {
        if (!reviewBlob) return;
        setIsUploadingAudio(true);
        try {
            const file = new File([reviewBlob], 'recording_' + Date.now() + '.webm', { type: 'audio/webm' });
            await uploadAudioToN8n(file, reviewDurationMs);
            clearReview();
        } finally {
            setIsUploadingAudio(false);
        }
    };

    const handleRerecord = () => {
        clearReview();
        startAudioRecording();
    };

    useEffect(() => {
        if (reviewAudioRef.current) {
            try { reviewAudioRef.current.playbackRate = playbackRate; } catch (e) {}
        }
    }, [playbackRate, reviewUrl]);

    useEffect(() => {
        const link = document.createElement('link');
        link.href = 'https://cdn.jsdelivr.net/npm/@n8n/chat/dist/style.css';
        link.rel = 'stylesheet';
        link.id = 'n8n-chat-css';
        if (!document.getElementById('n8n-chat-css')) {
            document.head.appendChild(link);
        }
        return () => {
            const existingLink = document.getElementById('n8n-chat-css');
            if (existingLink) {
                document.head.removeChild(existingLink);
            }
        };
    }, []);

    useEffect(() => {
        if (!showBot) return;
        sessions.forEach((session) => {
            const targetId = 'n8n-chat-widget-' + session.id;
            const container = document.getElementById(targetId);
            if (container && !n8nInitialized.current[session.id]) {
                const script = document.createElement('script');
                script.type = 'module';
                script.id = 'n8n-script-' + session.id;
                // n8n chat widget initialization script...
                // (tam icerik yukarida mevcut)
                document.head.appendChild(script);
                n8nInitialized.current[session.id] = true;
            }
        });
        return () => {
            sessions.forEach((session) => {
                const script = document.getElementById('n8n-script-' + session.id);
                if (script) document.head.removeChild(script);
                const style = document.getElementById('n8n-style-' + session.id);
                if (style) document.head.removeChild(style);
                n8nInitialized.current[session.id] = false;
            });
        };
    }, [showBot, sessions]);

    ─────────────────────────────────────────────────────────────── */


    if (isViewerPage && isMobile) return null;

    return (
        <Box className="chatbot-container" style={{
            position: 'fixed',
        }}>
            {showBot && <Box
                className={`chatbot-wrapper ${isDocked ? 'chatbot-docked' : ''}`}
                sx={{
                    display: 'flex',
                    boxShadow: '0 20px 60px rgba(102, 59, 185, 0.25)',
                    border: 'none',
                    background: '#ffffff',
                    opacity: showBot ? 1 : 0,
                    transition: 'opacity 0.3s ease-in-out',
                    position: 'relative',
                }}
            >
                <Box
                    className="chatbot-header"
                    sx={{
                        background: `linear-gradient(135deg, #663BB9 0%, #8B5CF6 50%, #A78BFA 100%)`,
                        backdropFilter: 'blur(10px)',
                        position: 'relative',
                        overflow: 'hidden',
                        '&::before': {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%)',
                            pointerEvents: 'none',
                        },
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, position: 'relative', zIndex: 1 }}>
                        <Box
                            sx={{
                                background: 'rgba(255, 255, 255, 0.2)',
                                borderRadius: '12px',
                                padding: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backdropFilter: 'blur(10px)',
                            }}
                        >
                            <img src={logo} alt="Orthero" width="48px" height="48px" />
                        </Box>
                        <Box>
                            <Box sx={{
                                fontWeight: 700,
                                fontSize: '17px',
                                letterSpacing: '0.3px',
                                color: 'white',
                            }}>
                                 Orthero Meeting
                            </Box>
                            <Box sx={{
                                fontSize: '11px',
                                color: 'rgba(255, 255, 255, 0.8)',
                                fontWeight: 500,
                            }}>
                               Her zaman yanınızdayız
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, position: 'relative', zIndex: 1 }}>
                        <Tooltip title={isDocked ? "Normal Mod" : "Tam Ekran"} placement="bottom">
                            <IconButton
                                onClick={toggleDockMode}
                                aria-label={isDocked ? "Default Mod" : "Dock Panel"}
                                size="small"
                                sx={{
                                    color: 'white',
                                    background: 'rgba(255, 255, 255, 0.1)',
                                    backdropFilter: 'blur(10px)',
                                    '&:hover': {
                                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                    },
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                    width: 32,
                                    height: 32,
                                }}
                            >
                                {isDocked ? (
                                    <DashboardIcon sx={{ fontSize: 18 }} />
                                ) : (
                                    <OpenInFullIcon sx={{ fontSize: 18 }} />
                                )}
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Kapat" placement="bottom">
                            <IconButton
                                onClick={toggleBot}
                                aria-label="Kapat"
                                size="small"
                                sx={{
                                    color: 'white',
                                    background: 'rgba(255, 255, 255, 0.1)',
                                    backdropFilter: 'blur(10px)',
                                    '&:hover': {
                                        backgroundColor: 'rgba(239, 68, 68, 0.9)',
                                    },
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                    width: 32,
                                    height: 32,
                                }}
                            >
                                <CloseIcon sx={{ fontSize: 18 }} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>

                <Box sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    height: '100%',
                }}>
                    <Box sx={{
                        background: 'linear-gradient(135deg, rgba(102,59,185,0.05) 0%, rgba(139,92,246,0.08) 100%)',
                        borderBottom: '1px solid #E5E7EB',
                    }}>
                                          <Box sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 1,
                        px: 2,
                        py: 1.5,
                        background: 'linear-gradient(135deg, rgba(102,59,185,0.05) 0%, rgba(139,92,246,0.08) 100%)',
                        borderBottom: '1px solid #E5E7EB',
                    }}>
                        <VideocamIcon sx={{ fontSize: 20, color: '#663BB9' }} />
                        <Box sx={{ fontSize: '13px', color: '#374151', lineHeight: 1.8 }}>
                            <Box component="span" sx={{ fontWeight: 600, fontSize: '14px', display: 'block', mb: 0.5 }}>
                            Portalla ilgili tüm sorularınız için online toplantı talep edebilirsiniz.
                            </Box>
                            <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
                                <li>Portalla ilgili tüm sorularınız</li>
                                <li>Yeni vaka ekleme</li>
                                <li>Analiz yükleme ve değerlendirme</li>
                                <li>Tedavi planı oluşturma</li>
                                <li>Hasta takibi ve raporlama</li>
                                <li>Teknik destek ve entegrasyon</li>
                                <li>Eğitim ve kullanım rehberliği</li>
                            </Box>
                        </Box>
                        </Box>
                    </Box>
                    <Box sx={{ flex: 1, overflow: 'hidden' }}>
                        <iframe
                            src={pipedriveSchedulerUrl}
                            title="Orthero Meeting"
                            style={{
                                width: '100%',
                                height: '100%',
                                border: 'none',
                            }}
                        />
                    </Box>
                </Box>
            </Box>}
            {!showBot && (
                <Zoom in={!showBot} timeout={400}>
                    <IconButton
                        className={`chatbot-toggle-btn ${isViewerPage ? 'chatbot-toggle-btn-viewer' : ''}`}
                        onClick={toggleBot}
                        aria-label="Chatbot Aç"
                        sx={{
                            background: 'linear-gradient(135deg, #663BB9 0%, #8B5CF6 50%, #A78BFA 100%)',
                            color: 'white',
                            width: 64,
                            height: 64,
                            boxShadow: '0 8px 32px rgba(102, 59, 185, 0.35)',
                            position: 'relative',
                            overflow: 'hidden',
                            '&::before': {
                                content: '""',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                background: 'radial-gradient(circle at 30% 30%, rgba(255,255,255,0.3) 0%, transparent 60%)',
                            },
                            '&:hover': {
                                background: 'linear-gradient(135deg, #8B5CF6 0%, #A78BFA 50%, #C4B5FD 100%)',
                                boxShadow: '0 12px 48px rgba(102, 59, 185, 0.5)',
                                transform: 'scale(1.08) translateY(-2px)',
                            },
                            '&:active': {
                                transform: 'scale(1.02)',
                            },
                            transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                        }}
                    >
                        <ChatIcon sx={{ fontSize: 30, position: 'relative', zIndex: 1 }} />
                    </IconButton>
                </Zoom>
            )}
        </Box>
    );
};
export default ChatbotComponent;
